import React from 'react'
import { Link } from 'react-router-dom'
import { ROOT } from '../domain/routes'

export const NotFound: React.FC = () => {
    return (
        <div>
            <p>Not found</p>
            <Link to={ROOT}>{'На главную'}</Link>
        </div>
    )
}
